import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjetoConfiguracao } from '../models/projeto-configuracao.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjetoConfiguracaoService {
  constructor(private http: HttpClient) {}

  show(id: number): Observable<ProjetoConfiguracao> {
    return this.http.get<ProjetoConfiguracao>(
      environment.apiUrl + '/projeto/config/' + id
    );
  }

  update(config: ProjetoConfiguracao): Observable<ProjetoConfiguracao> {
    return this.http.put<ProjetoConfiguracao>(
      environment.apiUrl + '/projeto/config/' + config.id,
      config
    );
  }
}
